module.exports = __webpack_public_path__ + "static/media/file.7d39976b.png";